"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROLE_TO_ALLOWED_CONFIGURATION_CONTEXT = exports.CUSTOMIZABLE_CONFIGURATION_DEFINITION = exports.CustomizableConfiguration = void 0;
const tslib_1 = require("tslib");
const __1 = require("../..");
const daily_dev_stats_1 = require("../daily-dev-stats");
const configuration_1 = require("../../types/configuration");
const user_role_type_1 = require("../../types/user-role-type");
const retro_1 = require("../../types/retro");
const developer_badges_1 = require("../../types/developer-badges");
const acumen_ui_version_1 = require("../../types/acumen-ui-version");
const moment_timezone_1 = tslib_1.__importDefault(require("moment-timezone"));
const sprint_1 = require("../../types/sprint");
const global_1 = require("../configuration/global");
const dashboard_1 = require("../configuration/dashboard");
const dashboard_api_1 = require("../configuration/dashboard-api");
const retro_report_1 = require("../configuration/retro-report");
const data_processor_1 = require("../configuration/data-processor");
const daily_dev_stats_2 = require("../configuration/daily-dev-stats");
const team_comparison_1 = require("../configuration/team-comparison");
// Note: to load all the locales
require("moment/min/locales");
const types_1 = require("./types");
const detected_deployment_1 = require("../detected-deployment");
const keys_1 = require("../configuration/keys");
var CustomizableConfiguration;
(function (CustomizableConfiguration) {
    CustomizableConfiguration["CountryCode"] = "CountryCode";
    CustomizableConfiguration["Locale"] = "Locale";
    CustomizableConfiguration["TimeZone"] = "TimeZone";
    CustomizableConfiguration["EstimationMethod"] = "EstimationMethod";
    CustomizableConfiguration["GoretroEstimationMethod"] = "GoretroEstimationMethod";
    CustomizableConfiguration["GitIgnoreFileList"] = "GitIgnoreFileList";
    CustomizableConfiguration["PlannedGracePeriod"] = "PlannedGracePeriod";
    CustomizableConfiguration["SubtaskSprintStrategy"] = "SubtaskSprintStrategy";
    CustomizableConfiguration["ExcludedObstacles"] = "ExcludedObstacles";
    CustomizableConfiguration["AnalyticsChartList"] = "AnalyticsChartList";
    CustomizableConfiguration["PrSizeToMergeTimeSlowThreshold"] = "PrSizeToMergeSlowThreshold";
    CustomizableConfiguration["PrSizeToMergeTimeFastThreshold"] = "PrSizeToMergeFastThreshold";
    CustomizableConfiguration["DevCycle"] = "DevCycle";
    CustomizableConfiguration["DeploymentDetection"] = "DeploymentDetection";
    CustomizableConfiguration["DevelopmentMethodology"] = "DevelopmentMethodology";
    CustomizableConfiguration["SprintIds"] = "SprintIds";
    CustomizableConfiguration["BoardIds"] = "BoardIds";
    CustomizableConfiguration["DoneStatuses"] = "DoneStatuses";
    CustomizableConfiguration["ContributorFilters"] = "ContributorFilters";
    CustomizableConfiguration["WorkforceHealthSelectedMetrics"] = "WorkforceHealthSelectedMetrics";
    CustomizableConfiguration["TeamComparisonSelectedMetrics"] = "TeamComparisonSelectedMetrics";
    CustomizableConfiguration["AcumenUiVersion"] = "AcumenUiVersion";
    CustomizableConfiguration["DevStatsBadgesLowActivityPercent"] = "DevStatsBadgesLowActivityPercent";
    CustomizableConfiguration["DevStatsBadgesMinNumberOfMergedPrsForPositiveBadges"] = "DevStatsBadgesMinNumberOfMergedPrsForPositiveBadges";
    CustomizableConfiguration["DevStatsBadgesVelocitySuperStarPercentileThreshold"] = "DevStatsBadgesVelocitySuperStarPercentileThreshold";
    CustomizableConfiguration["DevStatsBadgesVelocityNeedAttentionPercentileThreshold"] = "DevStatsBadgesVelocityNeedAttentionPercentileThreshold";
    CustomizableConfiguration["DevStatsBadgesVelocityNeedAttentionPrevPeriodDecreasePercentageThreshold"] = "DevStatsBadgesVelocityNeedAttentionPrevPeriodDecreasePercentageThreshold";
    CustomizableConfiguration["DevStatsBadgesVelocityCalculationSource"] = "DevStatsBadgesVelocityCalculationSource";
    CustomizableConfiguration["DevStatsBadgesVelocityOnTheRisePrevPeriodIncreasePercentageThreshold"] = "DevStatsBadgesVelocityOnTheRisePrevPeriodIncreasePercentageThreshold";
    CustomizableConfiguration["DevStatsBadgesVelocityOnTheRiseMinPercentileThreshold"] = "DevStatsBadgesVelocityOnTheRiseMinPercentileThreshold";
    CustomizableConfiguration["DevStatsBadgesHighPriorityDisable"] = "DevStatsBadgesHighPriorityDisable";
    CustomizableConfiguration["DevStatsBadgesHighPrioritySuperStarPercentileThreshold"] = "DevStatsBadgesHighPrioritySuperStarPercentileThreshold";
    CustomizableConfiguration["DevStatsBadgesHighPriorityTeamPlayerPercentileThreshold"] = "DevStatsBadgesHighPriorityTeamPlayerPercentileThreshold";
    CustomizableConfiguration["DevStatsBadgesHighPriorityOnTheRisePrevPeriodIncreasePercentageThreshold"] = "DevStatsBadgesHighPriorityOnTheRisePrevPeriodIncreasePercentageThreshold";
    CustomizableConfiguration["DevStatsBadgesHighPriorityOnTheRiseMinPercentileThreshold"] = "DevStatsBadgesHighPriorityOnTheRiseMinPercentileThreshold";
    CustomizableConfiguration["DevStatsBadgesHighPriorityMinNumberOfCompletedTasks"] = "DevStatsBadgesHighPriorityMinNumberOfCompletedTasks";
    CustomizableConfiguration["DevStatsBadgesPRSizeSuperStarPercentileThreshold"] = "DevStatsBadgesPRSizeSuperStarPercentileThreshold";
    CustomizableConfiguration["DevStatsBadgesPRSizeSuperStarPrSizeThreshold"] = "DevStatsBadgesPRSizeSuperStarPrSizeThreshold";
    CustomizableConfiguration["DevStatsBadgesPRSizeNeedAttentionPrSizeThreshold"] = "DevStatsBadgesPRSizeNeedAttentionPrSizeThreshold";
    CustomizableConfiguration["DevStatsBadgesPRSizeNeedAttentionPercentileThreshold"] = "DevStatsBadgesPRSizeNeedAttentionPercentileThreshold";
    CustomizableConfiguration["DevStatsBadgesPRSizeNeedAttentionPrevPeriodPrSizeIncreasePercentageThreshold"] = "DevStatsBadgesPRSizeNeedAttentionPrevPeriodPrSizeIncreasePercentageThreshold";
    CustomizableConfiguration["DevStatsBadgesPRSizeNeedAttentionMinPRSizeThreshold"] = "DevStatsBadgesPRSizeNeedAttentionMinPRSizeThreshold";
    CustomizableConfiguration["DevStatsBadgesPRSizeOnTheRisePrSizeThreshold"] = "DevStatsBadgesPRSizeOnTheRisePrSizeThreshold";
    CustomizableConfiguration["DevStatsBadgesPRSizeOnTheRisePrevPeriodPrSizeDecreasePercentageThreshold"] = "DevStatsBadgesPRSizeOnTheRisePrevPeriodPrSizeDecreasePercentageThreshold";
    CustomizableConfiguration["DevStatsBadgesPRCycleTimeSuperStarPercentileThreshold"] = "DevStatsBadgesPRCycleTimeSuperStarPercentileThreshold";
    CustomizableConfiguration["DevStatsBadgesPRCycleTimeNeedAttentionPercentileThreshold"] = "DevStatsBadgesPRCycleTimeNeedAttentionPercentileThreshold";
    CustomizableConfiguration["DevStatsBadgesPRCycleTimeNeedAttentionPrevPeriodIncreasePercentageThreshold"] = "DevStatsBadgesPRCycleTimeNeedAttentionPrevPeriodIncreasePercentageThreshold";
    CustomizableConfiguration["DevStatsBadgesPRCycleTimeNeedAttentionMinPercentileThreshold"] = "DevStatsBadgesPRCycleTimeNeedAttentionMinPercentileThreshold";
    CustomizableConfiguration["DevStatsBadgesPRCycleTimeOnTheRisePrevPeriodDecreasePercentageThreshold"] = "DevStatsBadgesPRCycleTimeOnTheRisePrevPeriodDecreasePercentageThreshold";
    CustomizableConfiguration["DevStatsBadgesPRCycleTimeOnTheRiseMaxPercentileThreshold"] = "DevStatsBadgesPRCycleTimeOnTheRiseMaxPercentileThreshold";
    CustomizableConfiguration["DevStatsBadgesReviewedPRsSuperStarPercentileThreshold"] = "DevStatsBadgesReviewedPRsSuperStarPercentileThreshold";
    CustomizableConfiguration["DevStatsBadgesReviewedPRsNeedAttentionPercentileThreshold"] = "DevStatsBadgesReviewedPRsNeedAttentionPercentileThreshold";
    CustomizableConfiguration["DevStatsBadgesReviewedPRsNeedAttentionOverTeamPercentageThreshold"] = "DevStatsBadgesReviewedPRsNeedAttentionOverTeamPercentageThreshold";
    CustomizableConfiguration["DevStatsBadgesReviewedPRsOnTheRisePrevPeriodIncreasePercentageThreshold"] = "DevStatsBadgesReviewedPRsOnTheRisePrevPeriodIncreasePercentageThreshold";
    CustomizableConfiguration["DevStatsBadgesReviewedPRsTeamPlayerRatioForMergedAndReviewedPrs"] = "DevStatsBadgesReviewedPRsTeamPlayerRatioForMergedAndReviewedPrs";
    CustomizableConfiguration["DevStatsBadgesReviewedPRsTeamPlayerMinPercentileThreshold"] = "DevStatsBadgesReviewedPRsTeamPlayerMinPercentileThreshold";
    CustomizableConfiguration["TeamBadgesNumberOfPeriodsForTrendCalculation"] = "TeamBadgesNumberOfPeriodsForTrendCalculation";
    CustomizableConfiguration["TeamBadgesVelocityTopPerformerPercentileThreshold"] = "TeamBadgesVelocityTopPerformerPercentileThreshold";
    CustomizableConfiguration["TeamBadgesVelocityOnTheRisePercentileThreshold"] = "TeamBadgesVelocityOnTheRisePercentileThreshold";
    CustomizableConfiguration["TeamBadgesVelocityNeedAttentionPercentileThreshold"] = "TeamBadgesVelocityNeedAttentionPercentileThreshold";
    CustomizableConfiguration["TeamBadgesVelocityDisable"] = "TeamBadgesVelocityDisable";
    CustomizableConfiguration["TeamBadgesAvgPRCycleTimeAwaitingReviewTopPerformerAwaitingReviewHours"] = "TeamBadgesAvgPRCycleTimeAwaitingReviewTopPerformerAwaitingReviewHours";
    CustomizableConfiguration["TeamBadgesAvgPRCycleTimeAwaitingReviewNeedAttentionAwaitingReviewHours"] = "TeamBadgesAvgPRCycleTimeAwaitingReviewNeedAttentionAwaitingReviewHours";
    CustomizableConfiguration["TeamBadgesAvgPRCycleTimeAwaitingReviewDisable"] = "TeamBadgesAvgPRCycleTimeAwaitingReviewDisable";
    CustomizableConfiguration["TeamBadgesAvgPRSizeTopPerformerPercentileThreshold"] = "TeamBadgesAvgPRSizeTopPerformerPercentileThreshold";
    CustomizableConfiguration["TeamBadgesAvgPRSizeTopPerformerPrSizeThresholdForTopPercentile"] = "TeamBadgesAvgPRSizeTopPerformerPrSizeThresholdForTopPercentile";
    CustomizableConfiguration["TeamBadgesAvgPRSizeTopPerformerPrSizeThreshold"] = "TeamBadgesAvgPRSizeTopPerformerPrSizeThreshold";
    CustomizableConfiguration["TeamBadgesAvgPRSizeOnTheRisePercentileThreshold"] = "TeamBadgesAvgPRSizeOnTheRisePercentileThreshold";
    CustomizableConfiguration["TeamBadgesAvgPRSizeNeedAttentionPrSizeThreshold"] = "TeamBadgesAvgPRSizeNeedAttentionPrSizeThreshold";
    CustomizableConfiguration["TeamBadgesAvgPRSizeNeedAttentionNegativeTrendPrSizeThreshold"] = "TeamBadgesAvgPRSizeNeedAttentionNegativeTrendPrSizeThreshold";
    CustomizableConfiguration["TeamBadgesAvgPRSizeDisable"] = "TeamBadgesAvgPRSizeDisable";
    CustomizableConfiguration["TeamBadgesAvgPRCycleTimeBadgeTopPerformerPercentileThreshold"] = "TeamBadgesAvgPRCycleTimeBadgeTopPerformerPercentileThreshold";
    CustomizableConfiguration["TeamBadgesAvgPRCycleTimeBadgeTopPerformerPrCycleTimeThresholdHoursForTopPercentile"] = "TeamBadgesAvgPRCycleTimeBadgeTopPerformerPrCycleTimeThresholdHoursForTopPercentile";
    CustomizableConfiguration["TeamBadgesAvgPRCycleTimeBadgeUseTopPerformerThresholdForTopPercentile"] = "TeamBadgesAvgPRCycleTimeBadgeUseTopPerformerThresholdForTopPercentile";
    CustomizableConfiguration["TeamBadgesAvgPRCycleTimeBadgeTopPerformerPrCycleTimeThresholdHours"] = "TeamBadgesAvgPRCycleTimeBadgeTopPerformerPrCycleTimeThresholdHours";
    CustomizableConfiguration["TeamBadgesAvgPRCycleTimeBadgeOnTheRisePercentileThreshold"] = "TeamBadgesAvgPRCycleTimeBadgeOnTheRisePercentileThreshold";
    CustomizableConfiguration["TeamBadgesAvgPRCycleTimeBadgeNeedAttentionPrCycleTimeThresholdHours"] = "TeamBadgesAvgPRCycleTimeBadgeNeedAttentionPrCycleTimeThresholdHours";
    CustomizableConfiguration["TeamBadgesAvgPRCycleTimeBadgeNeedAttentionNegativeTrendPrCycleTimeThresholdHours"] = "TeamBadgesAvgPRCycleTimeBadgeNeedAttentionNegativeTrendPrCycleTimeThresholdHours";
    CustomizableConfiguration["TeamBadgesAvgPRCycleTimeBadgeNeedAttentionPercentileThreshold"] = "TeamBadgesAvgPRCycleTimeBadgeNeedAttentionPercentileThreshold";
    CustomizableConfiguration["TeamBadgesAvgPRCycleTimeBadgeDisable"] = "TeamBadgesAvgPRCycleTimeBadgeDisable";
    CustomizableConfiguration["TeamBadgesPRReviewersPercentBadgeTopPerformerPercentageOfReviewers"] = "TeamBadgesPRReviewersPercentBadgeTopPerformerPercentageOfReviewers";
    CustomizableConfiguration["TeamBadgesPRReviewersPercentBadgeNeedAttentionPercentageOfReviewers"] = "TeamBadgesPRReviewersPercentBadgeNeedAttentionPercentageOfReviewers";
    CustomizableConfiguration["TeamBadgesPRReviewersPercentBadgeDisable"] = "TeamBadgesPRReviewersPercentBadgeDisable";
    CustomizableConfiguration["TeamBadgesWorkDistributionBugsPercentBadgeTopPerformerBugsPercentThreshold"] = "TeamBadgesWorkDistributionBugsPercentBadgeTopPerformerBugsPercentThreshold";
    CustomizableConfiguration["TeamBadgesWorkDistributionBugsPercentBadgeOnTheRiseBugsPercentThreshold"] = "TeamBadgesWorkDistributionBugsPercentBadgeOnTheRiseBugsPercentThreshold";
    CustomizableConfiguration["TeamBadgesWorkDistributionBugsPercentBadgeNeedAttentionBugsPercentThreshold"] = "TeamBadgesWorkDistributionBugsPercentBadgeNeedAttentionBugsPercentThreshold";
    CustomizableConfiguration["TeamBadgesWorkDistributionBugsPercentBadgeDisable"] = "TeamBadgesWorkDistributionBugsPercentBadgeDisable";
    CustomizableConfiguration["TeamBadgesMTTRBadgeTopPerformerPercentileThreshold"] = "TeamBadgesMTTRBadgeTopPerformerPercentileThreshold";
    CustomizableConfiguration["TeamBadgesMTTRBadgeTopPerformerMttrThresholdHoursForTopPercentile"] = "TeamBadgesMTTRBadgeTopPerformerMttrThresholdHoursForTopPercentile";
    CustomizableConfiguration["TeamBadgesMTTRBadgeTopPerformerMttrThresholdHours"] = "TeamBadgesMTTRBadgeTopPerformerMttrThresholdHours";
    CustomizableConfiguration["TeamBadgesMTTRBadgeNeedAttentionMttrThresholdHours"] = "TeamBadgesMTTRBadgeNeedAttentionMttrThresholdHours";
    CustomizableConfiguration["TeamBadgesMTTRBadgeNeedAttentionNegativeTrendMttrThresholdHours"] = "TeamBadgesMTTRBadgeNeedAttentionNegativeTrendMttrThresholdHours";
    CustomizableConfiguration["TeamBadgesMTTRBadgeDisable"] = "TeamBadgesMTTRBadgeDisable";
})(CustomizableConfiguration = exports.CustomizableConfiguration || (exports.CustomizableConfiguration = {}));
exports.CUSTOMIZABLE_CONFIGURATION_DEFINITION = {
    [CustomizableConfiguration.CountryCode]: {
        configurationKey: global_1.CONFIGURATION_KEYS.preferences.countryCode,
        requiresMaterializedViewRefresh: false,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "country code",
                inputType: types_1.CustomizableConfigInputType.SingleSelectStaticValues,
                possibleValues: moment_timezone_1.default.tz.countries(),
                nullable: false,
                position: 4,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault, configuration_1.ConfigurationEntityType.Team],
        removable: false
    },
    [CustomizableConfiguration.Locale]: {
        configurationKey: global_1.CONFIGURATION_KEYS.preferences.locale,
        requiresMaterializedViewRefresh: false,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "locale",
                inputType: types_1.CustomizableConfigInputType.SingleSelectStaticValues,
                possibleValues: moment_timezone_1.default.locales(),
                nullable: false,
                position: 6,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault, configuration_1.ConfigurationEntityType.Team],
        removable: false
    },
    [CustomizableConfiguration.TimeZone]: {
        configurationKey: global_1.CONFIGURATION_KEYS.preferences.timezone,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "time zone",
                inputType: types_1.CustomizableConfigInputType.SingleSelectStaticValues,
                possibleValues: moment_timezone_1.default.tz.names(),
                nullable: false,
                position: 7,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault, configuration_1.ConfigurationEntityType.Team],
        removable: false
    },
    [CustomizableConfiguration.EstimationMethod]: {
        configurationKey: global_1.CONFIGURATION_KEYS.preferences.issueTracking.estimationMethod,
        requiresMaterializedViewRefresh: false,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "estimation method",
                inputType: types_1.CustomizableConfigInputType.SingleSelectStaticValues,
                possibleValues: Object.values(__1.TaskEstimationMethod),
                nullable: false,
                position: 1,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault, configuration_1.ConfigurationEntityType.Team],
        removable: false
    },
    [CustomizableConfiguration.GoretroEstimationMethod]: {
        configurationKey: global_1.CONFIGURATION_KEYS.preferences.issueTracking.estimationMethod,
        requiresMaterializedViewRefresh: false,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "estimation method",
                inputType: types_1.CustomizableConfigInputType.SingleSelectStaticValues,
                possibleValues: Object.values(__1.TaskEstimationMethod)
                    .filter(estimatioMethod => estimatioMethod !== __1.TaskEstimationMethod.TShirtSize),
                nullable: false,
                position: 1,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault, configuration_1.ConfigurationEntityType.Team],
        removable: false
    },
    [CustomizableConfiguration.DevCycle]: {
        groupName: "Development cycle",
        configurationKey: dashboard_api_1.CONFIGURATION_KEYS.devCycles,
        requiresMaterializedViewRefresh: true,
        configParams: {
            type: {
                name: "integration type",
                inputType: types_1.CustomizableConfigInputType.SingleSelectStaticValues,
                possibleValues: Object.values(sprint_1.SprintIntegrationType),
                nullable: false,
                position: 1,
            },
            startingPoint: {
                name: "cycle starts on",
                inputType: types_1.CustomizableConfigInputType.Date,
                nullable: false,
                position: 2,
            },
            durationMs: {
                name: "cycle cadence",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 3,
            },
            statuses: {
                name: "include task with statuses",
                inputType: types_1.CustomizableConfigInputType.MultiSelectStaticValues,
                possibleValues: Object.values(__1.AcumenTaskStatus),
                nullable: false,
                position: 4,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault, configuration_1.ConfigurationEntityType.Team],
        nullable: false,
        removable: true
    },
    [CustomizableConfiguration.GitIgnoreFileList]: {
        configurationKey: global_1.CONFIGURATION_KEYS.preferences.ignoreFiles,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "git files to ignore",
                inputType: types_1.CustomizableConfigInputType.StringArray,
                nullable: false,
                position: 8,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault, configuration_1.ConfigurationEntityType.GitRepository],
        removable: false
    },
    [CustomizableConfiguration.PlannedGracePeriod]: {
        configurationKey: retro_report_1.CONFIGURATION_KEYS.sprints.unplannedTasksGraceHours,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Planning grace period",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 9,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault, configuration_1.ConfigurationEntityType.Team],
        removable: false
    },
    [CustomizableConfiguration.SubtaskSprintStrategy]: {
        configurationKey: retro_report_1.CONFIGURATION_KEYS.logic.subtaskSprintStrategy,
        requiresMaterializedViewRefresh: false,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Subtask estimates",
                inputType: types_1.CustomizableConfigInputType.SingleSelectStaticValues,
                possibleValues: Object.values(__1.SubtaskSprintStrategy),
                nullable: false,
                position: 2,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault, configuration_1.ConfigurationEntityType.Team],
        removable: false
    },
    [CustomizableConfiguration.ExcludedObstacles]: {
        configurationKey: retro_report_1.CONFIGURATION_KEYS.obstacles.excludedRules,
        requiresMaterializedViewRefresh: false,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "excluded obstacles rules",
                inputType: types_1.CustomizableConfigInputType.MultiSelectStaticValues,
                possibleValues: Object.values(retro_1.ObstacleRuleName),
                nullable: false,
                position: 10,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault, configuration_1.ConfigurationEntityType.Team],
        removable: false
    },
    [CustomizableConfiguration.AnalyticsChartList]: {
        configurationKey: dashboard_1.CONFIGURATION_KEYS.analytics.charts.list,
        requiresMaterializedViewRefresh: false,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Charts to show",
                inputType: types_1.CustomizableConfigInputType.MultiSelectStaticValues,
                possibleValues: Object.values(__1.ChartType),
                nullable: false,
                position: 11,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault, configuration_1.ConfigurationEntityType.Team],
        removable: false
    },
    [CustomizableConfiguration.PrSizeToMergeTimeSlowThreshold]: {
        configurationKey: dashboard_api_1.CONFIGURATION_KEYS.charts.prSizeToMergeTime.slowMergeTimeThresholdMs,
        requiresMaterializedViewRefresh: false,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Fast pull request threshold <",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 12,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault, configuration_1.ConfigurationEntityType.Team],
        removable: false
    },
    [CustomizableConfiguration.PrSizeToMergeTimeFastThreshold]: {
        configurationKey: dashboard_api_1.CONFIGURATION_KEYS.charts.prSizeToMergeTime.fastMergeTimeThresholdMs,
        requiresMaterializedViewRefresh: false,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Slow pull request threshold >",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 13,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault, configuration_1.ConfigurationEntityType.Team],
        removable: false
    },
    [CustomizableConfiguration.DeploymentDetection]: {
        groupName: "Deployment detection",
        configurationKey: data_processor_1.CONFIGURATION_KEYS.deployDetector.repoSettings,
        requiresMaterializedViewRefresh: false,
        configParams: {
            branchName: {
                name: "branch name",
                inputType: types_1.CustomizableConfigInputType.String,
                nullable: false,
                position: 1,
            },
            type: {
                name: "deployment type",
                inputType: types_1.CustomizableConfigInputType.SingleSelectStaticValues,
                possibleValues: Object.values(detected_deployment_1.DetectedDeploymentType),
                nullable: false,
                position: 2,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault, configuration_1.ConfigurationEntityType.GitRepository],
        nullable: false,
        removable: true
    },
    [CustomizableConfiguration.DevelopmentMethodology]: {
        configurationKey: global_1.CONFIGURATION_KEYS.preferences.issueTracking.developmentMethodology,
        requiresMaterializedViewRefresh: false,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "development methodology",
                inputType: types_1.CustomizableConfigInputType.SingleSelectStaticValues,
                possibleValues: Object.values(__1.DevelopmentMethodology),
                nullable: false,
                position: 14,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault, configuration_1.ConfigurationEntityType.Team],
        removable: false
    },
    [CustomizableConfiguration.SprintIds]: {
        configurationKey: keys_1.goretro.user.selected.sprintIds,
        requiresMaterializedViewRefresh: false,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Sprint ids",
                inputType: types_1.CustomizableConfigInputType.StringArray,
                nullable: false,
                position: 15,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.BoardIds]: {
        configurationKey: keys_1.goretro.user.selected.boardIds,
        requiresMaterializedViewRefresh: false,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Board ids",
                inputType: types_1.CustomizableConfigInputType.StringArray,
                nullable: false,
                position: 16,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.DoneStatuses]: {
        configurationKey: data_processor_1.CONFIGURATION_KEYS.taskStatus.mapping.config,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "definition of done",
                description: "Select which issue status should be considered as done. Changing this can take up to 30 minutes to be reflected in your sprint monitoring. Please contact support to remove disabled statuses.",
                inputType: types_1.CustomizableConfigInputType.MultiSelectDynamicValues,
                nullable: false,
                optionsFetcher: types_1.OptionsFetcher.CustomerStatuses,
                position: 3,
                dropdownButtonText: "Add Status",
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.ContributorFilters]: {
        configurationKey: keys_1.goretro.user.selected.contributorFilters,
        requiresMaterializedViewRefresh: false,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Data contributor filters",
                inputType: types_1.CustomizableConfigInputType.Object,
                nullable: true,
                position: -1,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.WorkforceHealthSelectedMetrics]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.selectedMetrics,
        requiresMaterializedViewRefresh: false,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Selected metrics",
                inputType: types_1.CustomizableConfigInputType.MultiSelectStaticValues,
                possibleValues: Object.values(daily_dev_stats_1.WorkforceHealthMetrics),
                nullable: false,
                position: -1,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.DataContributor],
        removable: false
    },
    [CustomizableConfiguration.TeamComparisonSelectedMetrics]: {
        configurationKey: team_comparison_1.CONFIGURATION_KEYS.selectedMetrics,
        requiresMaterializedViewRefresh: false,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Selected metrics",
                inputType: types_1.CustomizableConfigInputType.MultiSelectStaticValues,
                possibleValues: Object.values(daily_dev_stats_1.WorkforceHealthMetrics),
                nullable: false,
                position: -1,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.DataContributor],
        removable: false
    },
    [CustomizableConfiguration.AcumenUiVersion]: {
        configurationKey: global_1.CONFIGURATION_KEYS.preferences.uiVersion,
        requiresMaterializedViewRefresh: false,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Acumen UI version",
                inputType: types_1.CustomizableConfigInputType.SingleSelectStaticValues,
                possibleValues: Object.values(acumen_ui_version_1.AcumenUiVersion),
                nullable: true,
                position: -1,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.DataContributor],
        removable: false
    },
    [CustomizableConfiguration.DevStatsBadgesLowActivityPercent]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.badges.lowActivityPercent,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Low activity percent",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 1,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.DevStatsBadgesMinNumberOfMergedPrsForPositiveBadges]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.badges.minNumberOfMergedPrsForPositiveBadges,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Minimum number of merged PRs for positive badges",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 2,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.DevStatsBadgesVelocitySuperStarPercentileThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.badges.velocityBadge.superStarPercentileThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Superstar percentile threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 3,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.DevStatsBadgesVelocityNeedAttentionPercentileThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.badges.velocityBadge.needAttentionPercentileThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Need attention percentile threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 4,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.DevStatsBadgesVelocityNeedAttentionPrevPeriodDecreasePercentageThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.badges.velocityBadge.needAttentionPrevPeriodDecreasePercentageThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Need attention previous period decrease percentage threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 5,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.DevStatsBadgesVelocityCalculationSource]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.badges.velocityBadge.calculationMethod,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "How to calculate the velocity",
                inputType: types_1.CustomizableConfigInputType.SingleSelectStaticValues,
                possibleValues: Object.values(developer_badges_1.VelocityCalculationSource),
                nullable: false,
                position: 5.1,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.DevStatsBadgesVelocityOnTheRisePrevPeriodIncreasePercentageThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.badges.velocityBadge.onTheRisePrevPeriodIncreasePercentageThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "On the rise previous period increase percentage threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 6,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.DevStatsBadgesHighPriorityDisable]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.badges.highPriorityBadge.disable,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Disable badge",
                inputType: types_1.CustomizableConfigInputType.Boolean,
                nullable: false,
                position: 7,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.DevStatsBadgesHighPrioritySuperStarPercentileThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.badges.highPriorityBadge.superStarPercentileThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Superstar percentile threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 8,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.DevStatsBadgesHighPriorityTeamPlayerPercentileThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.badges.highPriorityBadge.teamPlayerPercentileThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Team player percentile threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 9,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.DevStatsBadgesHighPriorityOnTheRisePrevPeriodIncreasePercentageThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.badges.highPriorityBadge.onTheRisePrevPeriodIncreasePercentageThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "On the rise previous period increase percentage threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 10,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.DevStatsBadgesHighPriorityMinNumberOfCompletedTasks]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.badges.highPriorityBadge.minNumberOfCompletedTasks,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Minimum number of completed tasks",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 11,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.DevStatsBadgesPRSizeSuperStarPercentileThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.badges.prSizeBadge.superStarPercentileThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Superstar percentile threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 12,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.DevStatsBadgesPRSizeSuperStarPrSizeThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.badges.prSizeBadge.superStarPrSizeThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Superstar PR size threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 13,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.DevStatsBadgesPRSizeNeedAttentionPrSizeThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.badges.prSizeBadge.needAttentionPrSizeThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Need attention PR size threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 14,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.DevStatsBadgesPRSizeNeedAttentionPercentileThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.badges.prSizeBadge.needAttentionPercentileThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Need attention percentile threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 15,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.DevStatsBadgesPRSizeNeedAttentionPrevPeriodPrSizeIncreasePercentageThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.badges.prSizeBadge.needAttentionPrevPeriodPrSizeIncreasePercentageThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Need attention previous period PR Size increase percentage threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 16,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.DevStatsBadgesPRSizeOnTheRisePrSizeThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.badges.prSizeBadge.onTheRisePrSizeThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "On the rise PR Size threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 17,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.DevStatsBadgesPRSizeOnTheRisePrevPeriodPrSizeDecreasePercentageThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.badges.prSizeBadge.onTheRisePrevPeriodPrSizeDecreasePercentageThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "On the rise previous period PR Size decrease percentage threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 18,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.DevStatsBadgesPRCycleTimeSuperStarPercentileThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.badges.prCycleTimeBadge.superStarPercentileThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Superstar percentile threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 19,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.DevStatsBadgesPRCycleTimeNeedAttentionPercentileThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.badges.prCycleTimeBadge.needAttentionPercentileThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Need attention percentile threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 20,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.DevStatsBadgesPRCycleTimeNeedAttentionPrevPeriodIncreasePercentageThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.badges.prCycleTimeBadge.needAttentionPrevPeriodIncreasePercentageThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Need attention previous period increase percentage threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 21,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.DevStatsBadgesPRCycleTimeOnTheRisePrevPeriodDecreasePercentageThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.badges.prCycleTimeBadge.onTheRisePrevPeriodDecreasePercentageThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Need attention previous period decrease percentage threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 22,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.DevStatsBadgesPRSizeNeedAttentionMinPRSizeThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.badges.prSizeBadge.needAttentionMinPRSizeThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Need attention minimum PR size threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 23,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.DevStatsBadgesVelocityOnTheRiseMinPercentileThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.badges.velocityBadge.onTheRiseMinPercentileThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "On the rise minimum velocity percentile threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 24,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.DevStatsBadgesPRCycleTimeNeedAttentionMinPercentileThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.badges.prCycleTimeBadge.needAttentionMinPercentileThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Need attention minimum pr cycle time percentile threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 25,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.DevStatsBadgesPRCycleTimeOnTheRiseMaxPercentileThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.badges.prCycleTimeBadge.onTheRiseMaxPercentileThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "On the rise maximum pr cycle time percentile threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 26,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.DevStatsBadgesReviewedPRsSuperStarPercentileThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.badges.reviewedPRsBadge.superStarPercentileThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Superstar reviewed PRs percentage threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 27,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.DevStatsBadgesReviewedPRsNeedAttentionPercentileThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.badges.reviewedPRsBadge.needAttentionPercentileThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Need attention reviewed PRs percentage threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 28,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.DevStatsBadgesReviewedPRsNeedAttentionOverTeamPercentageThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.badges.reviewedPRsBadge.needAttentionOverTeamPercentageThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Need attention reviewed PRS over team percentile threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 29,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.DevStatsBadgesReviewedPRsOnTheRisePrevPeriodIncreasePercentageThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.badges.reviewedPRsBadge.onTheRisePrevPeriodIncreasePercentageThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "On the rise reviewed PRs increase percentile threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 30,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.DevStatsBadgesReviewedPRsTeamPlayerRatioForMergedAndReviewedPrs]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.badges.reviewedPRsBadge.teamPlayerRatioForMergedAndReviewedPrs,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Team player reviewed PRs ratio for merged and reviewed PRs",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 31,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.DevStatsBadgesReviewedPRsTeamPlayerMinPercentileThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.badges.reviewedPRsBadge.teamPlayerMinPercentileThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Team player reviewed PRs minimum percentile threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 32,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.DevStatsBadgesHighPriorityOnTheRiseMinPercentileThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.badges.highPriorityBadge.onTheRiseMinPercentileThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "On the rise minimum high priority tasks percentile threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 33,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.TeamBadgesNumberOfPeriodsForTrendCalculation]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.teamBadges.numberOfPeriodsForTrendCalculation,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Number of periods for trend calculation",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 34,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.TeamBadgesVelocityTopPerformerPercentileThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.teamBadges.velocityBadge.topPerformerPercentileThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Top performer percentile threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 35,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.TeamBadgesVelocityOnTheRisePercentileThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.teamBadges.velocityBadge.onTheRisePercentileThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "On the rise percentile threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 36,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.TeamBadgesVelocityNeedAttentionPercentileThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.teamBadges.velocityBadge.needAttentionPercentileThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Need attention percentile threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 37,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.TeamBadgesVelocityDisable]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.teamBadges.velocityBadge.disable,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Disable badge",
                inputType: types_1.CustomizableConfigInputType.Boolean,
                nullable: false,
                position: 38,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.TeamBadgesAvgPRCycleTimeAwaitingReviewTopPerformerAwaitingReviewHours]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.teamBadges.avgPRCycleTimeAwaitingReviewBadge.topPerformerAwaitingReviewHours,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Top performer awaiting review hours",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 39,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.TeamBadgesAvgPRCycleTimeAwaitingReviewNeedAttentionAwaitingReviewHours]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.teamBadges.avgPRCycleTimeAwaitingReviewBadge.needAttentionAwaitingReviewHours,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Need attention awaiting review hours",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 40,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.TeamBadgesAvgPRCycleTimeAwaitingReviewDisable]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.teamBadges.avgPRCycleTimeAwaitingReviewBadge.disable,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Disable badge",
                inputType: types_1.CustomizableConfigInputType.Boolean,
                nullable: false,
                position: 41,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.TeamBadgesAvgPRSizeTopPerformerPercentileThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.teamBadges.avgPRSizeBadge.topPerformerPercentileThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Top performer percentile threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 42,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.TeamBadgesAvgPRSizeTopPerformerPrSizeThresholdForTopPercentile]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.teamBadges.avgPRSizeBadge.topPerformerPrSizeThresholdForTopPercentile,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Top performer PR size threshold for top percentile",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 43,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.TeamBadgesAvgPRSizeTopPerformerPrSizeThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.teamBadges.avgPRSizeBadge.topPerformerPrSizeThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Top performer PR size threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 44,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.TeamBadgesAvgPRSizeOnTheRisePercentileThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.teamBadges.avgPRSizeBadge.onTheRisePercentileThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "On the rise percentile threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 45,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.TeamBadgesAvgPRSizeNeedAttentionPrSizeThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.teamBadges.avgPRSizeBadge.needAttentionPrSizeThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Need attention PR size threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 46,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.TeamBadgesAvgPRSizeNeedAttentionNegativeTrendPrSizeThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.teamBadges.avgPRSizeBadge.needAttentionNegativeTrendPrSizeThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Need attention negative trend PR size threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 47,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.TeamBadgesAvgPRSizeDisable]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.teamBadges.avgPRSizeBadge.disable,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Disable badge",
                inputType: types_1.CustomizableConfigInputType.Boolean,
                nullable: false,
                position: 48,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.TeamBadgesAvgPRCycleTimeBadgeTopPerformerPercentileThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.teamBadges.avgPRCycleTimeBadge.topPerformerPercentileThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Top performer percentile threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 49,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.TeamBadgesAvgPRCycleTimeBadgeTopPerformerPrCycleTimeThresholdHoursForTopPercentile]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.teamBadges.avgPRCycleTimeBadge.topPerformerPrCycleTimeThresholdHoursForTopPercentile,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Top performer PR cycle time threshold hours for top percentile",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 50,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.TeamBadgesAvgPRCycleTimeBadgeUseTopPerformerThresholdForTopPercentile]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.teamBadges.avgPRCycleTimeBadge.useTopPerformerThresholdForTopPercentile,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Use top performer threshold for top percentile",
                inputType: types_1.CustomizableConfigInputType.Boolean,
                nullable: false,
                position: 51,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.TeamBadgesAvgPRCycleTimeBadgeTopPerformerPrCycleTimeThresholdHours]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.teamBadges.avgPRCycleTimeBadge.topPerformerPrCycleTimeThresholdHours,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Top performer PR cycle time threshold hours",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 52,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.TeamBadgesAvgPRCycleTimeBadgeOnTheRisePercentileThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.teamBadges.avgPRCycleTimeBadge.onTheRisePercentileThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "On the rise percentile threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 53,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.TeamBadgesAvgPRCycleTimeBadgeNeedAttentionPrCycleTimeThresholdHours]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.teamBadges.avgPRCycleTimeBadge.needAttentionPrCycleTimeThresholdHours,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Need attention PR cycle time threshold hours",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 54,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.TeamBadgesAvgPRCycleTimeBadgeNeedAttentionNegativeTrendPrCycleTimeThresholdHours]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.teamBadges.avgPRCycleTimeBadge.needAttentionNegativeTrendPrCycleTimeThresholdHours,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Need attention negative trend PR cycle time threshold hours",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 55,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.TeamBadgesAvgPRCycleTimeBadgeNeedAttentionPercentileThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.teamBadges.avgPRCycleTimeBadge.needAttentionPercentileThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Need attention percentile threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 56,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.TeamBadgesAvgPRCycleTimeBadgeDisable]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.teamBadges.avgPRCycleTimeBadge.disable,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Disable badge",
                inputType: types_1.CustomizableConfigInputType.Boolean,
                nullable: false,
                position: 57,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.TeamBadgesPRReviewersPercentBadgeTopPerformerPercentageOfReviewers]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.teamBadges.prReviewersPercentBadge.topPerformerPercentageOfReviewers,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Top performer percentage of reviewers",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 58,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.TeamBadgesPRReviewersPercentBadgeNeedAttentionPercentageOfReviewers]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.teamBadges.prReviewersPercentBadge.needAttentionPercentageOfReviewers,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Need attention percentage of reviewers",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 59,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.TeamBadgesPRReviewersPercentBadgeDisable]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.teamBadges.prReviewersPercentBadge.disable,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Disable badge",
                inputType: types_1.CustomizableConfigInputType.Boolean,
                nullable: false,
                position: 60,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.TeamBadgesWorkDistributionBugsPercentBadgeTopPerformerBugsPercentThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.teamBadges.workDistributionBugsPercentBadge.topPerformerBugsPercentThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Top performer bugs percent threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 61,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.TeamBadgesWorkDistributionBugsPercentBadgeOnTheRiseBugsPercentThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.teamBadges.workDistributionBugsPercentBadge.onTheRiseBugsPercentThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "On the rise bugs percent threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 62,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.TeamBadgesWorkDistributionBugsPercentBadgeNeedAttentionBugsPercentThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.teamBadges.workDistributionBugsPercentBadge.needAttentionBugsPercentThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Need attention bugs percent threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 63,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.TeamBadgesWorkDistributionBugsPercentBadgeDisable]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.teamBadges.workDistributionBugsPercentBadge.disable,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Disable badge",
                inputType: types_1.CustomizableConfigInputType.Boolean,
                nullable: false,
                position: 64,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.TeamBadgesMTTRBadgeTopPerformerPercentileThreshold]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.teamBadges.mttrBadge.topPerformerPercentileThreshold,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Top performer percentile threshold",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 65,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.TeamBadgesMTTRBadgeTopPerformerMttrThresholdHoursForTopPercentile]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.teamBadges.mttrBadge.topPerformerMttrThresholdHoursForTopPercentile,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Top performer MTTR threshold hours for top percentile",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 66,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.TeamBadgesMTTRBadgeTopPerformerMttrThresholdHours]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.teamBadges.mttrBadge.topPerformerMttrThresholdHours,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Top performer MTTR threshold hours",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 67,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.TeamBadgesMTTRBadgeNeedAttentionMttrThresholdHours]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.teamBadges.mttrBadge.needAttentionMttrThresholdHours,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Need attention MTTR threshold hours",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 68,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.TeamBadgesMTTRBadgeNeedAttentionNegativeTrendMttrThresholdHours]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.teamBadges.mttrBadge.needAttentionNegativeTrendMttrThresholdHours,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Need attention negative trend MTTR threshold hours",
                inputType: types_1.CustomizableConfigInputType.Number,
                nullable: false,
                position: 69,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
    [CustomizableConfiguration.TeamBadgesMTTRBadgeDisable]: {
        configurationKey: daily_dev_stats_2.CONFIGURATION_KEYS.teamBadges.mttrBadge.disable,
        requiresMaterializedViewRefresh: true,
        configParams: {
            [types_1.SINGLE_CONFIG_KEY]: {
                name: "Disable badge",
                inputType: types_1.CustomizableConfigInputType.Boolean,
                nullable: false,
                position: 70,
            }
        },
        contextTypes: [configuration_1.ConfigurationEntityType.CustomerDefault],
        removable: false
    },
};
exports.ROLE_TO_ALLOWED_CONFIGURATION_CONTEXT = {
    [user_role_type_1.UserRoleType.Administrator]: types_1.SUPPORTED_CONFIGURATION_CONTEXTS,
    [user_role_type_1.UserRoleType.Executive]: types_1.SUPPORTED_CONFIGURATION_CONTEXTS,
    [user_role_type_1.UserRoleType.Manager]: [
        configuration_1.ConfigurationEntityType.Team,
        configuration_1.ConfigurationEntityType.DataContributor
    ],
    // TODO: (ACM-4806) make all configurations readonly for go retro team members
    // Note: enables GET requests for go retro team members.
    // won't affect acumen team members since the cog is hidden for them.
    [user_role_type_1.UserRoleType.Engineer]: types_1.SUPPORTED_CONFIGURATION_CONTEXTS,
    [user_role_type_1.UserRoleType.DefaultUser]: [],
    [user_role_type_1.UserRoleType.GoRetroSuperadmin]: []
};
//# sourceMappingURL=configuration.js.map